import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function Blog() {
  useEffect(() => {
    // Update meta tags
    document.title = 'Why AutoCAD and Bluebeam Revu are Essential for Concrete Formwork | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn why AutoCAD and Bluebeam Revu are the industry-standard tools for precision formwork drawings and material takeoffs in Vancouver construction projects.');
    }

    // Add Schema.org JSON-LD for Article
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Why AutoCAD and Bluebeam Revu are Essential for Your Concrete Formwork Workflow',
      description: 'Learn why AutoCAD and Bluebeam Revu are the industry-standard tools for precision formwork drawings and material takeoffs in Vancouver construction projects.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2024-05-01',
      dateModified: new Date().toISOString().split('T')[0],
    });

    if (!document.head.querySelector('script[data-schema="blog"]')) {
      script.setAttribute('data-schema', 'blog');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
